import { blockedInstacartAccount } from './blockedInstacartAccount';
import { createInstacartAccount } from './createInstacartAccount';
import { downloadInstacartAccounts } from './downloadInstacartAccounts';
import { fetchInstacartAccount } from './fetchInstacartAccount';
import { fetchInstacartAccounts } from './fetchInstacartAccounts';
import { updateInstacartAccount } from './updateInstacartAccount';

export const instacartAccountService = {
  blockedInstacartAccount,
  createInstacartAccount,
  downloadInstacartAccounts,
  fetchInstacartAccount,
  fetchInstacartAccounts,
  updateInstacartAccount,
};
